<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <!-- border-zinc-950/10 dark:border-white/10 shadow-lg -->
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border"
        [ngClass]="{
            'shadow-lg border border-zinc-950/10 dark:border-white/10': source !== 'modal'
          }">
        <form [formGroup]="fundingSourceForm" (ngSubmit)="onSave()">
            <h1 *ngIf="source !== 'modal'" class="heading">
                {{fundingSourceId ? 'Edit' : 'Add'}}
            </h1>
            <hr *ngIf="source !== 'modal'" class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <div class="space-y-1">
                    <label class="subheading">
                        Name <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="title" type="text" />
                        </div>
                        <div *ngIf="submitted && form.title.errors">
                            <p *ngIf="form.title.errors.required" class="pt-1 text-red-600 text-xs">
                                Name is required
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Contact Number <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="contactNumber" type="text" />
                        </div>
                        <div *ngIf="submitted && form.contactNumber.errors">
                            <p *ngIf="form.contactNumber.errors.required" class="pt-1 text-red-600 text-xs">
                                Contact Number is required
                            </p>
                            <p *ngIf="submitted && form.contactNumber.errors?.minlength || submitted && form.contactNumber.errors.maxlength" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Phone Number
                    </label>
                    <div>
                        <div>
                            <input formControlName="phoneNumber" type="text"/>
                        </div>
                        <div *ngIf="submitted && form.phoneNumber.errors">
                            <p *ngIf="submitted && form.phoneNumber.errors?.minlength || submitted && form.phoneNumber.errors.maxlength" class="pt-1 text-red-600 text-xs">
                                Minimum 10 digits are required and maximum 13 digits are allowed
                            </p>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email <span class="text-red-600">*</span>
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="text" />
                        </div>
                        <div *ngIf="submitted && form.email.errors">
                            <p *ngIf="form.email.errors.required" class="pt-1 text-red-600 text-xs">
                                Email is required
                            </p>
                            <p *ngIf="form.email.errors.email" class="pt-1 text-red-600 text-xs">
                                Invalid Email format
                            </p>
                        </div>
                    </div>
                </div>
                <ng-container formGroupName="address">
                    <div class="space-y-1">
                        <label class="subheading">
                            Address <span class="text-red-600">*</span>
                        </label>
                        <div>
                            <input googlePlace (onSelect)="onSelectAddress($event)" (input)="onChangeAddress()" formControlName="name" type="text"
                                placeholder="Enter the address" />
                            <!-- <div
                                *ngIf="submitted && (addressForm.get('name')?.errors || addressForm.get('coords')?.errors || addressForm.get('coords')?.value?.length === 0)">
                                <p *ngIf="(addressForm.get('name')?.errors?.required || 
                                        addressForm.get('coords')?.errors?.required || 
                                        addressForm.get('coords')?.value?.length === 0)"
                                    class="pt-1 text-red-600 text-xs">
                                    Address is required
                                </p>
                            </div> -->
                            <div *ngIf="submitted">
                                <div class="error">
                                    <p *ngIf="addressForm.get('name')?.errors?.required" class="mt-2 text-red-600 text-xs">
                                        Address is required
                                    </p>
                                    <p *ngIf="addressForm?.errors?.invalidAddress"
                                        class="mt-2 text-red-600 text-xs">
                                        Invalid address (select from the dropdown)
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="space-y-1">
                        <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">
                            City
                        </label>
                        <div>
                            <input formControlName="city" type="text" placeholder="" />
                            <div
                            *ngIf="submitted && addressForm.get('city')?.errors">
                            <p *ngIf="addressForm.get('city')?.errors?.required"
                                class="pt-1 text-red-600 text-xs">
                                City is required
                            </p>
                        </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">
                            State
                        </label>
                        <div>
                            <input formControlName="state" type="text" placeholder="" />
                            <div
                            *ngIf="submitted && (addressForm.get('state')?.errors)">
                            <p *ngIf="addressForm.get('state')?.errors?.required"
                                class="pt-1 text-red-600 text-xs">
                                State is required
                            </p>
                        </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">
                            Zip Code
                        </label>
                        <div>
                            <div>
                                <input formControlName="zipCode" type="text" />
                            </div>
                            <div *ngIf="submitted && addressForm.get('zipCode')?.errors">
                                <p *ngIf="addressForm.get('zipCode')?.errors?.required"
                                    class="pt-1 text-red-600 text-xs">
                                    Zip Code is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="space-y-1">
                        <label class="subheading">
                            Apt/Suite/Room
                        </label>
                        <div>
                            <div>
                                <input formControlName="aptSuiteRoom" type="text" />
                            </div>
                        </div>
                    </div>
                </ng-container>
                 <div class="space-y-1">
                    <label class="subheading">Time Zone</label>
                    <div>
                      <select formControlName="timeZone">
                        <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                      </select>
                      <div *ngIf="submitted && form.timeZone.errors">
                        <p *ngIf="form.timeZone.errors.required" class="pt-1 text-red-600 text-xs">
                          Time Zone is required
                        </p>
                      </div>
                    </div>
                  </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Account Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="accountStatus">
                                <option value="normal">Normal</option>
                                <option value="freeze-account">Freeze Account</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Status
                    </label>
                    <div>
                        <div>
                            <select formControlName="isActive" (change)="onStatusChange($event)">
                                <option [value]="true">Active</option>
                                <option [value]="false">Inactive</option>
                            </select>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="fundingSourceId">
                <div class="space-y-1">
                    <label class="subheading">Set as Default</label>
                    <div class="sm:col-span-2 flex items-center mt-6 space-x-2">
                        <label
                            class="relative inline-flex h-6 w-12 flex-shrink-0 cursor-pointer rounded-full border-zinc-950/10 dark:border-white/10 bg-zinc-950/5 dark:bg-white/5 text-sm-dark transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <input type="checkbox" formControlName="isDefault" class="peer sr-only" (change)="onChangeToggle($event)"
                                aria-checked="fundingSourceForm.get('isDefault')?.value" />
                            <span
                                class="pointer-events-none relative inline-block h-6 w-6 transform rounded-full bg-white shadow ring-0 transition-all duration-200 ease-in-out peer-checked:translate-x-6 peer-checked:bg-green-500">
                                <span *ngIf="!fundingSourceForm.get('isDefault')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-0"
                                    aria-hidden="true">
                                    <svg class="h-3 w-3 text-red-500" fill="none" viewBox="0 0 12 12">
                                        <path d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                                <span *ngIf="fundingSourceForm.get('isDefault')?.value"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 peer-checked:opacity-100"
                                    aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                        stroke="currentColor" class="h-3 w-3 text-white">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                    </svg>
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
                </ng-container>

                <div class="space-y-1">
                    <label class="subheading">
                        Google Client ID
                    </label>
                    <div>
                        <div>
                            <input formControlName="googleClientId" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Apple Client ID
                    </label>
                    <div>
                        <div>
                            <input formControlName="appleClientId" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Play Store URL
                    </label>
                    <div>
                        <div>
                            <input formControlName="playStoreUrl" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        App Store URL
                    </label>
                    <div>
                        <div>
                            <input formControlName="appStoreUrl" type="text" />
                        </div>
                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Portal URL
                    </label>
                    <div>
                        <div>
                            <input formControlName="portalUrl" type="text" />
                        </div>
                    </div>
                </div>

                <div class="space-y-1 sm:col-span-2">
                    <label class="subheading after:ml-0.5 after:text-red-500 after:content-['*']">
                        Profile Image
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">

                                <img [src]="profileImageURL ? profileImageURL : 'assets/images/company-placeholder.png'"
                                    alt="Profile Image"
                                    class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*" style="width: 100%;"
                                        (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                                </label>
                            </div>
                            <div *ngIf="form.profileImageURL.errors && submitted">
                            <div *ngIf="form.profileImageURL.errors.required" class="error">
                                <p class="mt-2 text-red-600 text-xs">
                                    Profile Image is required
                                </p>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>

            </section>
            <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="flex justify-end gap-4">
                <!-- <button *ngIf="fundingSourceId" type="button" class="btn btn-secondary" (click)="copyIdToClipBoard()">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                        class="h-6 w-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
                    </svg>
                    Copy ID
                </button> -->
                <button type="submit" class="btn btn-secondary">
                    {{fundingSourceId ? 'Update' : 'Create'}}
                </button>
            </section>
        </form>
    </div>
</section>